// extracted by mini-css-extract-plugin
export default {"sitesVars":"SharePointSites_dark_sitesVars__5VAXA"};